export const API_URL = process.env.NODE_ENV === 'production' ? 'https://learnlanguage.today/api/admin/' : 'http://127.0.0.1:8000/api/admin/'
export const DEBUG = process.env.NODE_ENV !== 'production'
export const PIXABAY_USERNAME = 'karapetyan_s'
export const PIXABAY_KEY = '12732537-a46ac7a6a4e92153780932c9f'
export const SHUTTERSTOCK_CLIENT_ID = 'd2809-50f4c-83a1b-64447-98624-05de3'
export const SHUTTERSTOCK_CLIENT_SECRET = '19b82-07b06-147c5-15f00-69ccc-ff10e'

export default API_URL
